var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBigTick = function SvgBigTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.053 1.929a.8.8 0 0 0-.328.304c-.044.07-1.354 2.407-2.912 5.194A653.378 653.378 0 0 1 6.94 12.54c-.023.026-.058.047-.077.047-.02 0-.837-.669-1.817-1.487a1091.97 1091.97 0 0 0-1.901-1.586c-.275-.224-.544-.268-.789-.128-.265.152-.466.465-.468.729-.002.182.075.333.254.5.365.339 3.812 3.187 3.955 3.268.739.414 1.716.135 2.16-.616.19-.322 5.668-10.125 5.751-10.293.162-.326.118-.622-.123-.828-.249-.213-.625-.311-.832-.217",
    fillRule: "evenodd",
    fill: "#000"
  })));
};

export default SvgBigTick;